import React from 'react';
import {
    yMapHintContainer, yMapHintDescription, yMapHintInfo, yMapHintTitle
} from '@search/ymap/src/hint';

import { declensionByNumber } from '@search/helpers/src/declensionByNumber';
import { formatPrice } from '@search/helpers/src/formatPrice';
import { formatAreaRange } from '@search/helpers/src/formatArea';
import { Currency } from '@search/filter-enums/enums/Currency';

import { OfferYMapPlacemarkTooltip } from '../placemark/Placemark';
import { OfferYMapHouseMultiProps } from './HouseMultiProps';

export function OfferYMapHouseMulti({
    minPrice,
    minArea,
    maxArea,
    count,
    coordinates,
    isActive,
    id,
    url,
    onClick,
    targetBlank = true,
    isHighlighted,
    zIndexes,
    dataTest
}: OfferYMapHouseMultiProps) {
    const realtyStr = declensionByNumber(count, [ 'дом', 'дома', 'домов' ]);

    const hintLayout = yMapHintContainer(`
        ${yMapHintInfo(`
            ${yMapHintTitle(`${count} ${realtyStr}`)}
            ${minArea && maxArea ? yMapHintDescription(formatAreaRange({ minArea, maxArea })) : ''}
        `)}
    `);

    const minPriceStr = formatPrice({
        value: minPrice.rubPrice ?? minPrice.value,
        currency: minPrice.rubPrice ? Currency.RUB : minPrice.currency,
        inWords: true
    });

    return (<OfferYMapPlacemarkTooltip
        id={id}
        url={url}
        targetBlank={targetBlank}
        onClick={onClick}
        dataTest={dataTest}
        isActive={isActive}
        title={`от ${minPriceStr}`}
        total={String(count)}
        coordinates={{ y: coordinates.latitude, x: coordinates.longitude }}
        hintLayout={hintLayout}
        isHighlighted={isHighlighted}
        zIndexes={zIndexes}
    />);
}
